import styled from '@emotion/styled'
import { Typography } from '@mui/material'

export const StyledUpdatedText = styled(Typography)`
    color: ${({ theme }) => theme.palette.other.secondary_light};
`
